export default {
  title: '4. Aging in Community',
  visionTitle: 'VISION',
  visionSubHeader: "New York City's senior homeowners have the resources they need to avoid scams, stay in their homes, and plan for their futures.",
  visionBody: 'Seniors are among the most vulnerable homeowners in New York City: They are frequently the target of scammers and require additional services to help age in their communities, as well as additional support to protect them from financial shocks. They are also more diverse and much more likely to be immigrants  than seniors in other parts of the country; many live in multi-generational households. Affordable estate planning is an often overlooked need for families that are "house rich" but "cash poor," but is essential to help families preserve and transfer wealth over generations, particularly for black and Latinx families. Foreclosures following reverse mortgage defaults are another major concern, as is financial abuse and deed theft scams.',
  datapoint: 'Senior homeowners over the age of 65 increased by 73,000 (29 percent) between 2008 and 2017, while the number of non-senior homeowners decreased by 87,000 (11 percent) over the same period.',
  goalTitle: 'GOALS',
  goals: [
    {
      id: 'estate planning',
      content: 'Provide <strong>estate planning</strong> resources so that seniors and their families can plan for the future and keep their homes in their families.'
    },
    {
      id: 'resources',
      content: 'Expand <strong>affordable financing</strong> resources for <strong>home repairs</strong> and <strong>accessibility retrofits</strong> and assist homeowners with contracting.'
    },
    {
      id: 'protections',
      content: 'Increase protections from <strong>financial abuse and scams</strong> by investing in community outreach and education for seniors, their families, and their neighbors. Toughen laws, require LLC transparency, increase enforcement, and ensure legal services resources to better assist victims of scams.'
    },
    {
      id: 'health care',
      content: 'Partner with health care providers, social workers, and other senior service providers to develop cross-referrals for senior homeowners in need of housing, medical, or other supports.'
    },
    {
      id: 'outreach',
      content: 'Increase outreach, education, and assistance for seniors struggling with <strong>property tax</strong> and <strong>water delinquencies</strong>.'
    },
    {
      id: 'reverse mortgage',
      content: 'Support <strong>reverse mortgage borrowers</strong> and develop safer lending products. As more homeowners become seniors, we can expect increased numbers of reverse mortgage borrowers and reverse mortgage defaults. In addition to averting reverse mortgage foreclosure, greater resources are needed to educate borrowers about the risks and their responsibilities.'
    },
    {
      id: 'financial assistance',
      content: 'Explore financial assistance models for home repair and use of equity as <strong>alternatives to reverse mortgages</strong>, which jeopardize housing stability while increasing the racial wealth gap.'
    },
    {
      id: 'alternative models',
      content: 'Develop alternative models and programs for senior homeowners to leverage their home for improved financial stability, such as condo/coop conversions and homesharing.'
    },
    {
      id: 'seniors',
      content: 'Ensure that seniors who wish to exit homeownership have access to affordable rental housing in their neighborhood, including Section 202 affordable housing with supportive services for seniors.'
    }
  ]
};
